// @flow
import React from 'react';
import type { Node } from 'react';
import styled, { type StyledComponent } from 'styled-components';

import { ALIGNMENT } from '../layout.constants';

export type Props = {
  children: Node,
  style: ?Object,
  vAlign: ALIGNMENT,
  hAlign: ALIGNMENT,
  noWrap: ?boolean,
};

export const HorizontalWrapper: StyledComponent<Props> = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: ${props => props.hAlign.toString()};
  align-items: ${props => props.vAlign.toString()};
  flex-wrap: ${props => (props.noWrap ? 'nowrap' : 'wrap')};
  flex-shrink: 0;
`;

const HorizontalLayout = (props: Props) => (
  <HorizontalWrapper {...props}>{props.children}</HorizontalWrapper>
);

HorizontalLayout.defaultProps = {
  style: {},
  vAlign: ALIGNMENT.START,
  hAlign: ALIGNMENT.START,
  noWrap: false,
};

export default HorizontalLayout;



// WEBPACK FOOTER //
// ../react-lib/src/components/layouts/HorizontalLayout/HorizontalLayout.jsx